import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import * as React from 'react';

export type CompensableKilometerLimitProps = {
    compensableKilometerLimit: string;
    onChange: () => void;
    deductionLegend: string;
    deductionInputLabel: string;
};

const CompensableKilometerLimit = ({
    compensableKilometerLimit,
    onChange,
    deductionLegend,
    deductionInputLabel
}: CompensableKilometerLimitProps) => {
    return (
        <fieldset>
            <legend>{deductionLegend}</legend>
            <FormGroup controlId="photographerTravelDeduction">
                <ControlLabel>{deductionInputLabel}</ControlLabel>
                <FormControl
                    type="number"
                    name="compensableKilometerLimit"
                    value={compensableKilometerLimit}
                    onChange={onChange}
                    aria-label={'compensableKilometerLimit'}
                />
            </FormGroup>
        </fieldset>
    );
};

export default CompensableKilometerLimit;
